import React, { FC } from 'react';
import styled from 'styled-components';
import { DataTable as PrimeReactDataTable } from 'primereact/datatable';
import {
  ColumnProps,
  Column as PrimeReactColumn,
  ColumnBodyOptions
} from 'primereact/column';
import Text from 'components/UI/Text';
import Tooltip from 'components/UI/Tooltip';
import { resolveFieldData } from 'utils/functions';
import { observer } from 'mobx-react';
import { HIGHLIGHTED_ROW_CLASS_NAME } from 'core/constants';

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment */


// Deprecated, use default primereact DataTable instead
export const DataTable = styled(PrimeReactDataTable)`
  &&& {
    .p-filter-column {
      padding: 0.5rem 0.5rem;
      min-width: 53px;
    }

    .p-column-filter-element {
      min-width: 5rem;
      max-width: 11.25rem;
    }

    .p-resizable-column {
      padding: 1.5rem 0.5rem;
      min-width: 8rem;
    }

    .p-hidden-space {
      display: none;
    }
  }

  .${HIGHLIGHTED_ROW_CLASS_NAME} {
    td {
      background-color: var(--orange-200);
      color: black;
    }
  }
`;

export const GenericBody: FC<ColumnBodyOptions> = (
  data: any,
  props: CustomColumnProps,
  ..._parameters: any
) => {
  const { field, altField } = props;
  return <GenericBodyContainer data={data} field={field} altField={altField} />;
};

export const GenericBodyContainer: FC<{
  data: any;
  field: string | undefined;
  altField: string | undefined;
}> = observer(({ data, field, altField }) => {
  const text: string =
    resolveFieldData(field, data) || resolveFieldData(altField, data) || '';

  return (
    <Tooltip arrow title={text} placement="top">
      <Text size="md" singleline>
        {text}
      </Text>
    </Tooltip>
  );
});

export interface CustomColumnProps extends ColumnProps {
  altField?: string;
  bodyProps?: any;
}

export const Column: FC<CustomColumnProps> = () => {
  return null;
};

/* this exist to add a default 'body' prop to the DataTable Columns
  primereact ignores the Columns altogether and looks directly into their props, <Column/> never gets rendered.
*/

Column.defaultProps = {
  // @ts-ignore
  ...PrimeReactColumn.defaultProps,
  footer: null,
  body: GenericBody,
};

export { PrimeReactDataTable };
